import { FEATURE_FLAGS } from '../../../featureFlags';
import { frontendURL } from '../../../helper/URLHelper';
import BoardsOverview from './overview/Index.vue';
import Board from './item/Index.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/wgpt-boards'),
      meta: {
        featureFlag: FEATURE_FLAGS.WGPT_BOARDS,
        permissions: ['administrator', 'agent'],
      },
      component: Index,
      children: [
        {
          path: '',
          name: 'boards_overview',
          component: BoardsOverview,
          meta: {
            featureFlag: FEATURE_FLAGS.WGPT_BOARDS,
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: ':boardId',
          name: 'board_item',
          component: Board,
          meta: {
            featureFlag: FEATURE_FLAGS.WGPT_BOARDS,
            permissions: ['administrator', 'agent'],
          },
        },
      ],
    },
  ],
};
